import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Screening, ScreeningLight } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';

@Component({
  selector: 'app-property-decision-mgr',
  templateUrl: './property-decision-mgr.component.html',
  styleUrls: ['./property-decision-mgr.component.less']
})
export class PropertyDecisionMgrComponent implements OnInit {

  @Input() public screeningToEdit: ScreeningLight;

  constructor(public screenings: ScreeningService, public toast: ToastrService) { }

  ngOnInit() {
  }

  setEditState(s: ScreeningLight){
    s.editing = false;
    s.warned = false;
  }

  public savePropertyDecsion(s: ScreeningLight) {
    this.screenings.GetScreeningById(s.id).subscribe((scc: Screening) =>{
      scc.propertyDecision = s.propertyDecision;
      this.screenings.UpdateScreeningPIT(scc).subscribe((rsp : any)=>{
        this.toast.success('Property decision set successfully.');
        s.editing = false;
      })
    },(err:any)=>{
      this.toast.error('Error setting property decision.');
    })
  }

}
